import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Mission } from './components/Mission';
import { Ecosystem } from './components/Ecosystem';
import { Activities } from './components/Activities';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0" data-mp="3fbjcp7zok1xj">
      <Header data-id="element-1" data-mp="2rkx51htl8jo2" />
      <main className="flex-grow" data-id="element-2" data-mp="2rkdy0w5h7fot">
        <Hero data-id="element-3" data-mp="2rlf7wxar9w4y" />
        <Mission data-id="element-4" data-mp="2rl6xrd60p4xg" />
        <Ecosystem data-id="element-5" data-mp="2rikqzfqyatga" />
        <Activities data-id="element-6" data-mp="2mmce69087cca" />
      </main>
      <Footer data-id="element-7" data-mp="2mn5aeg1k6jg6" />
    </div>;
}